import { exists } from '@/helpers/utilities';
import { MaskInput } from "maska";

export let mixin = ({ node = null, config = {} } = {}) => {
    if (!node) return false;

    let state = {
        node,
        config,
        previousValue: '',
        input: node.querySelector('input'),
    };

    let module = {
        passAttributes() {
            state.input.setAttribute('pattern', state.node.getAttribute('pattern'));
        },
        preventInput(e) {
            if (state.input.checkValidity()) {
                state.previousValue = state.input.value;
            } else {
                state.input.value = state.previousValue;
            }
        },
        initMaskPlugin() {
            new MaskInput(state.input, {
                mask: state.node.dataset.maska,
                eager: true,
            });  
        },
        setEventBindings() {
            state.input.addEventListener('input', this.preventInput.bind(this));
        },
        init() {
            if (!exists(state.node) || !exists(state.input)) return;
            if(state.node.getAttribute('pattern')){
                this.passAttributes();
                this.setEventBindings();
            }

            if (state.node.getAttribute('data-maska')) {
                this.initMaskPlugin();   
            }
        },
    };

    return module.init();
};

export default {
    init({ selector, config = {} }) {
        let selected = document.querySelectorAll(selector);
        if (!selected.length) return;

        return [...selected].map((node, index) => {
            return mixin({ node, config });
        });
    },
};
